import { isEmpty } from 'lodash/fp';
import { useSelector } from 'react-redux';

import selectHasPartnerReferrer from '../../../../selectors/select-has-partner-referrer';
import type { Offer } from '../../types';

type UseShouldShowOfferBannerOptions = {
  activeOffers?: Offer[];
};

const useShouldShowOfferBanner = ({ activeOffers }: UseShouldShowOfferBannerOptions = {}) => {
  const isPartnerReferral = useSelector(selectHasPartnerReferrer);

  if (isPartnerReferral) return false;
  if (activeOffers !== undefined && isEmpty(activeOffers)) return false;
  return true;
};

export default useShouldShowOfferBanner;
